namespace GeniuzPOS.Purchase {
    export interface SysTenderRow {
        TenderType?: string;
        TenderCode?: string;
        TenderName?: string;
    }

    export namespace SysTenderRow {
        export const idProperty = 'TenderCode';
        export const nameProperty = 'TenderName';
        export const localTextPrefix = 'Purchase.SysTender';
        export const lookupKey = 'Purchase.SysTender';

        export function getLookup(): Q.Lookup<SysTenderRow> {
            return Q.getLookup<SysTenderRow>('Purchase.SysTender');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            TenderType = "TenderType",
            TenderCode = "TenderCode",
            TenderName = "TenderName"
        }
    }
}
